/* AT-AT Sabers — Habillage Halloween 2026 (chargé uniquement si halloween_enabled) */
(function () {
  // Fin de l'offre : 31.10.2026 23:59:59 heure de Paris (UTC+1 à cette date)
  var END = Date.UTC(2026, 9, 31, 22, 59, 59);
  var root = document.documentElement;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var left = END - Date.now();
    if (left <= 0) { root.classList.add('hw-ended'); return false; }
    var d = Math.floor(left / 864e5);
    var h = Math.floor((left % 864e5) / 36e5);
    var m = Math.floor((left % 36e5) / 6e4);
    var txt = d > 0 ? 'Fin dans ' + d + ' j ' + pad(h) + ' h' : 'Fin dans ' + pad(h) + ' h ' + pad(m) + ' min';
    var els = document.querySelectorAll('[data-hw-countdown]');
    for (var i = 0; i < els.length; i++) { if (els[i].textContent !== txt) els[i].textContent = txt; }
    return true;
  }
  if (tick()) setInterval(tick, 30000);

  // Page produit : le rappel suit la variante sélectionnée (Pixel = offre active)
  function syncPdp() {
    var box = document.querySelector('[data-hw-pdp]');
    if (!box) return;
    var ids = (box.getAttribute('data-hw-variants') || '').split(',');
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var current = (input && input.value) ||
      new URLSearchParams(location.search).get('variant') ||
      box.getAttribute('data-hw-current');
    box.classList.toggle('is-off', ids.indexOf(String(current)) === -1);
  }
  if (document.querySelector('[data-hw-pdp]')) {
    syncPdp();
    document.addEventListener('change', function () {
      setTimeout(syncPdp, 80);
      setTimeout(syncPdp, 500);
    });
  }
})();
